import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Toast } from 'app/shared/toast/toast';
import { ChangePasswordComponent } from '../../change-password/change-password.component';
import { TwofactorComponent } from '../../twofactor/twofactor.component';
import {MatLegacySlideToggleChange as MatSlideToggleChange} from '@angular/material/legacy-slide-toggle';

@Component({
  selector: 'app-edit-security',
  templateUrl: './edit-security.component.html',
  styleUrls: ['./edit-security.component.css']
})
export class EditSecurityComponent implements OnInit {
  headerHistory: string[] = ['device', 'location', 'currentDate'];
  headerLogin: string[] = ['loginDate', 'device', 'location', 'status'];
  user: any;

  isHiddenLog: boolean = false;
  isHiddenSign: boolean = false;
  isTwoFacLoginChecked: any;
  isTwoFacDocumentSignChecked: any;
  isTwoFacSignGoogleChecked: any;
  isTwoFacLoginGoogleChecked: any;
  isTwoFactorLogin: any;
  isTwoFactorLoginGoogle: any;
  isTwoFactorSign: any;
  isTwoFactorSignGoogle: any;
  verificationGoogleChecked: any;
  start: number = 0;
  limit: number = 5;
  end: number = this.limit + this.start;
  dataHistory: any;
  dataLoginWeek: any;
  dataSourceHistory: any;
  dataSourceLoginWeek: any;
  isShowFactorLogin: boolean = false;
  isShowFactorSign: boolean = false;
  isExpanded1 = true;
  isExpanded2 = true;

  @ViewChild('hpaginator', { static: true }) hpaginator: MatPaginator;
  @ViewChild('wpaginator', { static: true }) wpaginator: MatPaginator;
  private twofactor: MatDialogRef<TwofactorComponent>;

  constructor(protected service: IdexService, private dialog: MatDialog, public toast: Toast) {}

  ngOnInit(): void {
    this.user = this.service.user;
    this.getAuditLog();
    this.getAuditLastLogin();
    this.getStatusFactor();
  }

  getAuditLog() {
    this.service.getHistoryLogin().subscribe((response) => {
      this.dataSourceHistory = response;
      this.dataHistory = this.getTableDataHistory(this.start, this.end);
    });
  }

  getAuditLastLogin() {
    this.service.getHistoryLastlogin().subscribe((response) => {
      this.dataSourceLoginWeek = response;
      this.dataLoginWeek = this.getTableLoginWeek(this.start, this.end);
    });
  }

  // Opens the change password dialog
  openChangePassword() {
    this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
      data: this
    });
  }

  onSlideToggleLogChange($event: MatSlideToggleChange) {
    this.isHiddenLog = !$event.checked;
    if (!this.isShowFactorLogin) {
       this.isTwoFacLoginGoogleChecked = false;
    }
  }

  onSlideToggleSignChange($event: MatSlideToggleChange){
    this.isHiddenSign = !$event.checked;
    if (!this.isShowFactorSign) {
       this.isTwoFacSignGoogleChecked = false;
    }
  }

  // Retrieves the status of two-factor authentication from the service
  getStatusFactor() {
    this.isHiddenLog = true;
    this.isHiddenSign = true;
    this.service.getProfile()
    .subscribe((data: any) => {
    this.isTwoFacLoginGoogleChecked = data.isTwoFactorLoginGoogle;
    this.isTwoFacSignGoogleChecked = data.isTwoFactorSignGoogle;
    this.verificationGoogleChecked = data.verificationGoogle;
    if(data.isTwoFactorLogin || data.isTwoFactorLoginGoogle){
      this.isShowFactorLogin = true;
      this.isHiddenLog = false;
    }
    if(data.isTwoFactorSign || data.isTwoFactorSignGoogle){
      this.isShowFactorSign = true;
      this.isHiddenSign = false;
    }
    }, error => {
      this.toast.error(error.message);
    });
  }

  updateStatusFactor() {
    this.isTwoFactorLogin = this.isTwoFacLoginGoogleChecked ? true : false;
    this.isTwoFactorSign = this.isTwoFacSignGoogleChecked ? true : false;
    const isTwoFactorGoogle = (this.isTwoFacLoginGoogleChecked || this.isTwoFacSignGoogleChecked);
    let isEnableLoginGoogle = false;
    let isEnableSignGoogle = false;
    let isCallUpdate = false;
    
    if (this.isShowFactorLogin || this.isShowFactorSign) {
        if (isTwoFactorGoogle && !this.verificationGoogleChecked) {
          this.twofactor = this.dialog.open(TwofactorComponent, {
            disableClose: true,
            data: {token: null, qrCodeUrl: this.service.user.qrCodeUrl, mode: 'update'}
          });
          this.twofactor.afterClosed().subscribe(result => {
            if (result === 200) {
                isCallUpdate = false;
                this.verificationGoogleChecked = false;
                if (this.isShowFactorLogin) {
                  if (this.isTwoFacLoginGoogleChecked) {
                    this.isTwoFactorLogin = true;
                    isEnableLoginGoogle = true;
                    this.verificationGoogleChecked = true; 
                  } else {
                    this.isTwoFactorLogin = true;
                    isEnableLoginGoogle = this.isTwoFacLoginGoogleChecked;
                  }  
                }
                if(this.isShowFactorSign){
                  if(this.isTwoFacSignGoogleChecked){
                    this.isTwoFactorSign = true;
                    isEnableSignGoogle = true;
                    this.verificationGoogleChecked = true;
                  } else {
                    this.isTwoFactorSign = true;
                    isEnableSignGoogle = this.isTwoFacSignGoogleChecked;
                  }
                }
                this.updateStatus(this.isTwoFactorLogin, isEnableLoginGoogle, this.isTwoFactorSign, isEnableSignGoogle, this.verificationGoogleChecked);
            } else {
                this.isTwoFacLoginGoogleChecked = false;
                this.isTwoFacSignGoogleChecked = false;
            }
          });
        } else {
          isCallUpdate = true;
          this.verificationGoogleChecked = false;    
          if (this.isShowFactorLogin) {
            if (this.isTwoFacLoginGoogleChecked) {
              this.isTwoFactorLogin = true;
              isEnableLoginGoogle = true;
              this.verificationGoogleChecked = true; 
            } else {
              this.isTwoFactorLogin = true;
              isEnableLoginGoogle = this.isTwoFacLoginGoogleChecked;
            }  
          }
          if(this.isShowFactorSign){
            if(this.isTwoFacSignGoogleChecked){
              this.isTwoFactorSign = true;
              isEnableSignGoogle = true; 
              this.verificationGoogleChecked = true;
            } else {
              this.isTwoFactorSign = true;
              isEnableSignGoogle = this.isTwoFacSignGoogleChecked;
            }
          }
        }
    } else {
      isCallUpdate = true;
      this.isTwoFactorLogin = false;
      this.isTwoFactorSign = false;
      this.verificationGoogleChecked = false;
    }

    if (isCallUpdate) {
       this.updateStatus(this.isTwoFactorLogin, isEnableLoginGoogle, this.isTwoFactorSign, isEnableSignGoogle, this.verificationGoogleChecked);
    } 
  }

  updateStatus(isTwoFactorLogin: boolean, isEnableLoginGoogle: boolean, isTwoFactorSign: boolean, isEnableSignGoogle: boolean, isVerifyGoogle: boolean){
    this.service.updateStatusFactor(isTwoFactorLogin, isEnableLoginGoogle,
      isTwoFactorSign, isEnableSignGoogle, isVerifyGoogle)
      .subscribe((response) => {
      this.toast.success(response);
    });
  }

  getTableDataHistory(start, end){
    return this.dataSourceHistory.filter((value, index) => index >= start && index < end)
  }

  getTableLoginWeek(start, end){
    return this.dataSourceLoginWeek.filter((value, index) => index >= start && index < end)
  }

  updateIndex() {
    this.start = this.end;
    this.end = this.limit + this.start;
  }

  loadMoreHistory(e) {
    const tableViewHeight = e.target.offsetHeight // viewport
    const tableScrollHeight = e.target.scrollHeight // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    
    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;   
    if (scrollLocation > limit) {
      let data = this.getTableDataHistory(this.start, this.end);
      this.dataHistory = this.dataHistory.concat(data);
      this.updateIndex();
    }  
  }
  
  loadMoreLoginWeek(e) {
    const tableViewHeight = e.target.offsetHeight // viewport
    const tableScrollHeight = e.target.scrollHeight // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    
    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;  
    if (scrollLocation > limit) {
      const data = this.getTableLoginWeek(this.start, this.end);
      this.dataLoginWeek = this.dataLoginWeek.concat(data);
      this.updateIndex();
    }  
  }
  
  setExpand1(isExpand: boolean): void {
    this.isExpanded1 = isExpand;
  }

  setExpand2(isExpand: boolean): void {
    this.isExpanded2 = isExpand;
  }
}